// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 434) return "static/css/434.0233b77bb.chunk.css";
	// return url for filenames based on template
	return undefined;
};